module.exports = __webpack_public_path__ + "img/mark-active.65303d19.png";